module.exports = __webpack_public_path__ + "static/media/logo.7c0da0aa.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Home/logo.svg
// module id = 877
// module chunks = 0